import store from '@store'
import { memberApplicablePrepaidOptions, sizeOptions, storeOptions, memberPetOptions } from "@utils/ipetbooking-options";
import formatDate from '@utils/format-date';
import parseISO from 'date-fns/parseISO';

/**
 * 取得預設分店類型
 * @param query
 * @returns {string}
 */
export function getDefaultStoreType(query) {
  const storeTypeList = [
    'store',
    'home'
  ];

  const valueStore = () => {
    const isIncludesStoreType = storeTypeList.includes(query);

    return isIncludesStoreType
      ? query
      : ''
  };

  const defaultStore = storeTypeList[0] || '';

  return valueStore() || defaultStore
}

/**
 * 取得預設分店
 * @param query
 * @param storeType
 * @returns {*|string}
 */
export function getDefaultStore(query, storeType = 'all') {
  const stores = storeOptions({
    type: 'open',
    storeType
  });

  const valueStore = () => {
    const storesAliasList = stores.map(item => item.alias);
    const isIncludesStore = storesAliasList.includes(query);

    return isIncludesStore
      ? query
      : ''
  };

  const defaultStore = stores[0]?.alias || '';

  return valueStore() || defaultStore
}

/**
 * 取得預設會員寵物類別別名
 * @param queryIsUserMemberPet
 * @param queryPetId
 * @param queryCategory
 * @returns {*}
 */
export function getDefaultCategoryAlias({
  queryIsUserMemberPet,
  queryPetId,
  queryCategory
}) {
  const isUserMemberPet = getDefaultIsUserMemberPet(queryIsUserMemberPet);
  const petItem = getDefaultPetItem(queryPetId);
  const category = getDefaultCategory(queryCategory);

  return isUserMemberPet && petItem.categoryAlias
    ? petItem.categoryAlias
    : getDefaultCategory(category);
}

/**
 * 取得預設寵物類別
 * @param queryIsUserMemberPet
 * @param queryPetId
 * @param queryCategory
 * @returns {*}
 */
export function getDefaultCategory(query) {
  const petCategories = store.state.merchant.currentMerchant?.petCategories || [];

  const valueCategory = () => {
    const petCategoriesAliasList = petCategories.map(item => item.alias);
    const isIncludesCategory = petCategoriesAliasList.includes(query);

    return isIncludesCategory
      ? query
      : ''
  };

  const defaultCategory = petCategories[0]?.alias || '';

  return valueCategory() || defaultCategory
}

/**
 * 取得預設體型
 * @param query
 * @param category
 * @returns {string}
 */
export function getDefaultSize(query, category) {
  if(category) {
    const petSize = sizeOptions(category);

    const valueSize = () => {
      const petSizeAliasList = petSize.map(item => item.value);
      const isIncludesSize = petSizeAliasList.includes(query);

      return isIncludesSize
        ? query
        : ''
    };

    const defaultSize = petSize[0]?.value || '';

    return valueSize() || defaultSize
  } else {
    return ''
  }
}

/**
 * 取得預設日期
 * @param query
 * @returns {*}
 */
export function getDefaultDate(query) {
  const isBigThanToday = parseISO(query) > new Date();

  return isBigThanToday
    ? formatDate(query, 'yyyy-MM-dd')
    : formatDate(new Date(), 'yyyy-MM-dd')
}

/**
 * 取得預設使否使用會員寵物
 * @param query
 * @returns {boolean}
 */
export function getDefaultIsUserMemberPet(query) {
  const formatBoolean = (value = '') => {
    switch(value.toString()
      .toLowerCase()
      .trim()) {
      case "yes":
      case "true":
      case "1":
        return true;
      case "no":
      case "false":
      case "0":
      case null:
        return false;
      default:
        return Boolean(value);
    }
  };

  const valueIsUserMemberPet = () => {
    return query || query === false
      ? formatBoolean(query) ?? store.getters['auth/isLoggedIn']
      : store.getters['auth/isLoggedIn'];
  };

  // return store.getters['auth/isLoggedIn'] && !!memberPetOptions()[0]
  return store.getters['auth/isLoggedIn']
    ? valueIsUserMemberPet()
    : false
}


/**
 * 取得預設使否使用包套方案
 * @param query
 * @returns {boolean}
 */
export function getDefaultIsUsePrepaid(query) {
  const formatBoolean = (value = '') => {
    switch(value.toString()
      .toLowerCase()
      .trim()) {
      case "yes":
      case "true":
      case "1":
        return true;
      case "no":
      case "false":
      case "0":
      case null:
        return false;
      default:
        return Boolean(value);
    }
  };

  const valueIsUserMemberPet = () => {
    return formatBoolean(query)
  };

  return store.getters['auth/isLoggedIn']
    ? valueIsUserMemberPet()
    : false
}

/**
 * 取得預設會員寵物ID
 * @param query
 * @returns {number|string}
 */
export function getDefaultPetId(query) {
  const memberPetList = store.state.auth?.currentMemberPetList || [];

  const valuePetId = () => {
    const memberPetsIdList = memberPetList.map(item => item.id);
    const isIncludesPetId = memberPetsIdList.includes(Number(query));

    return isIncludesPetId
      ? Number(query)
      : ''
  };

  const defaultPetId = memberPetList[0]?.id || '';

  return valuePetId() || defaultPetId
}

/**
 * 取得預設會員寵物項目
 * @param query
 * @returns {number|string}
 */
export function getDefaultApplicablePrepaidPetItem({
  queryPerpaidId,
  queryPetId
}) {
  const memberPetList = store.state.auth?.currentMemberPetList || [];

  const applicablePrepaidItem = getDefaultApplicablePrepaidItem(queryPerpaidId);
  const applicableEvents = applicablePrepaidItem.prepaid?.applicableEvents?.filter(item => item.used < item.times) || [];
  const applicableEventsSizeAliasList = applicableEvents.map(item => item.sizeAlias);

  const isIncludesStoreApplicableEventsSize = (sizeAlias) => {
    return applicableEventsSizeAliasList.includes(sizeAlias)
  };

  const valuePetItem = () => {
    const memberPetItems = memberPetList.filter(item => {
      return item.id === Number(queryPetId)
    });

    if(memberPetItems[0]) {
      const isIncludes = isIncludesStoreApplicableEventsSize(memberPetItems[0].sizeAlias);

      return isIncludes
        ? memberPetItems[0]
        : ''
    } else {
      return ''
    }
  };

  const defaultPetItem = () => {
    let petItem = '';

    memberPetList.some(item => {
      if(isIncludesStoreApplicableEventsSize(item.sizeAlias)) {
        petItem = item;
        return true
      }
    });

    return petItem;
  };

  return valuePetItem() || defaultPetItem()
}

/**
 * 取得預設會員寵物ID
 * @param query
 * @returns {number|string}
 */
export function getDefaultApplicablePrepaidPetId({
  queryPerpaidId,
  queryPetId
}) {
  const memberPetList = store.state.auth?.currentMemberPetList || [];

  const applicablePrepaidItem = getDefaultApplicablePrepaidItem(queryPerpaidId);
  const applicableEvents = applicablePrepaidItem.prepaid?.applicableEvents?.filter(item => item.used < item.times) || [];
  const applicableEventsSizeAliasList = applicableEvents.map(item => item.sizeAlias);

  const isIncludesStoreApplicableEventsSize = (sizeAlias) => {
    return applicableEventsSizeAliasList.includes(sizeAlias)
  };

  const valuePetId = () => {
    const memberPetItems = memberPetList.filter(item => {
      return item.id === Number(queryPetId)
    });

    if(memberPetItems[0]) {
      const isIncludes = isIncludesStoreApplicableEventsSize(memberPetItems[0].sizeAlias);

      return isIncludes
        ? memberPetItems[0].id
        : ''
    } else {
      return ''
    }
  };

  const defaultPetId = () => {
    let petId = '';

    memberPetList.some(item => {
      if(isIncludesStoreApplicableEventsSize(item.sizeAlias)) {
        petId = item.id;
        return true
      }
    });

    return petId;
  };

  return valuePetId() || defaultPetId()
}

/**
 * 取得預設適用會員包套方案項目
 * @param query
 * @returns {T|{}}
 */
export function getDefaultApplicablePrepaidItem(query) {
  const currentApplicablePrepaidOrderList = memberApplicablePrepaidOptions();

  const valueApplicablePrepaidItem = () => {
    const memberApplicablePrepaidIdItems = currentApplicablePrepaidOrderList.filter(item => {
      return item.id === query
    });

    return memberApplicablePrepaidIdItems[0] || ''
  };

  const defaultApplicablePrepaidItem = () => {
    return currentApplicablePrepaidOrderList[0] || {}
  };

  return valueApplicablePrepaidItem() || defaultApplicablePrepaidItem()
}

/**
 * 取得預設適用會員包套方案項目
 * @param query
 * @returns {T|{}}
 */
export function getDefaultApplicablePrepaidPetCategoriesAlias({ queryPrepaId } = {}) {
  // const applicablePrepaidItem = getDefaultApplicablePrepaidItem(queryPrepaId);

  // return ''
}

/**
 * 取得預設寵物項目
 * @param query
 * @returns {T|{}|string}
 */
export function getDefaultPetItem(query) {
  const memberPets = store.state.auth?.currentMemberPetList || [];

  const valuePetItem = () => {
    const memberPetItems = memberPets.filter(item => {
      return item.id === Number(query)
    });

    return memberPetItems[0] || ''
  };

  const defaultPetItem = memberPets[0] || '';

  return valuePetItem() || defaultPetItem
}

/**
 * 取得預設會員寵物分類型名
 * @param queryIsUserMemberPet
 * @param queryPetId
 * @param querySize
 * @param queryCategory
 * @returns {*|string}
 */
export function getDefaultSizeAlias({
  queryIsUserMemberPet,
  queryPetId,
  querySize,
  queryCategory
}) {
  const isUserMemberPet = getDefaultIsUserMemberPet(queryIsUserMemberPet);
  const petItem = getDefaultPetItem(queryPetId);
  const category = getDefaultCategory(queryCategory);

  return isUserMemberPet && petItem.sizeAlias
    ? petItem.sizeAlias
    : getDefaultSize(querySize, category);
}

/**
 * 取得預設商家篩選
 * @param query
 * @returns {*[]|[]}
 */
export function getDefaultFilterStore(query) {
  const stores = storeOptions({
    type: 'open'
  });

  const valueFilterStore = () => {
    const filterStore = [];

    stores.forEach(item => {
      const filterStoreList = (query || '').split(',');
      const isIncludesStore = filterStoreList.includes(item.alias);
      const checkChildren = (data) => {
        if(data.children) {
          data.children.forEach(childrenItem => {
            const isIncludesStoreChildren = filterStoreList.includes(childrenItem.alias);

            if(isIncludesStoreChildren) {
              filterStore.push(childrenItem.alias)
            }
          });

          checkChildren(data.children);
        }
      };

      if(isIncludesStore) {
        filterStore.push(item.alias)
      }

      checkChildren(item);
    });

    return filterStore;
  };

  return valueFilterStore() || []
}

/**
 * 取得預設寵物篩選
 * @param query
 * @returns {*[]|[]}
 */
export function getDefaultFilterCategory(query) {
  const petCategories = store.state.merchant.currentMerchant?.petCategories || [];

  const valueFilterCategory = () => {
    const filterCategory = [];

    petCategories.forEach(item => {
      const filterCategoryList = (query || '').split(',');
      const isIncludesCategory = filterCategoryList.includes(item.alias);
      const checkChildren = (data) => {
        if(data.children) {
          data.children.forEach(childrenItem => {
            const isIncludesCategoryChildren = filterCategoryList.includes(childrenItem.alias);

            if(isIncludesCategoryChildren) {
              filterCategory.push(childrenItem.alias)
            }
          });

          checkChildren(data.children);
        }
      };

      if(isIncludesCategory) {
        filterCategory.push(item.alias)
      }

      checkChildren(item);
    });

    return filterCategory;
  };

  return valueFilterCategory() || []
}

/**
 * 取得預設預約禁用日期
 * @param storeAlias
 * @param prepaidId
 * @param type ['v-date-picker', 'element']
 * @returns {unknown[]|*[]}
 */
export function getDefaultReservationDisabledDayList({ storeAlias, prepaidId, type = 'v-date-picker' }) {
  const storeItem = () => {
    const activeStoreAlias = () => {
      if(prepaidId) {
        const activeMemberApplicablePrepaidItem = () => {
          const memberPetOptionsItems = memberApplicablePrepaidOptions()
            .filter(item => {
              return item.value === prepaidId
            });

          return memberPetOptionsItems[0] || {}
        };

        return activeMemberApplicablePrepaidItem().prepaid?.stores[0]?.alias || ''
      } else {
        return storeAlias
      }
    };

    const stores = (store.state.merchant.currentMerchant?.stores || [])
      .filter(item => {
        return !!item.state
      });

    const storeItems = stores.filter(item => {
      return item.alias === activeStoreAlias()
    });

    return storeItems[0] || ''
  };

  return storeItem().params && storeItem().params.serviceTimeSetting
    ? Object.keys(storeItem().params.serviceTimeSetting)
      .filter(key => {
        return !storeItem().params.serviceTimeSetting[key].isOpen
      })
      .map(item => {
        switch(type) {
          case 'v-date-picker':
            return item === '7'
              ? 1
              : Number(item) + 1;
          case 'element':
          default:
            return item
        }
      })
    : []
}
